"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
require("./sis-tree-node-expand.component.css");
var TreeNodeExpand = /** @class */ (function () {
    function TreeNodeExpand() {
        /**
         * The node that contains the expand icon. This node would be expanded when the expand node is clicked.
         * @type {TreeNode}
         * @private
         */
        this._parent = null;
    }
    Object.defineProperty(TreeNodeExpand.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        set: function (parent) {
            this._parent = parent;
        },
        enumerable: true,
        configurable: true
    });
    TreeNodeExpand = __decorate([
        core_1.Component({
            
            selector: "sis-tree-node-expand",
            template: require('./sis-tree-node-expand.component.html'),
        })
        /**
         * TreeNodeCollapse enables the users to expand the nodes and to provide the design of expand node.
         */
        ,
        __metadata("design:paramtypes", [])
    ], TreeNodeExpand);
    return TreeNodeExpand;
}());
exports.TreeNodeExpand = TreeNodeExpand;
//# sourceMappingURL=sis-tree-node-expand.component.js.map